<template>
	<div class="input-multiline">
		<label>{{ label }}</label>
		<input-text v-for="(line, index) in lines" :key="line" v-model="lines[index]" append-icon="essentials/basics/close-circle" :inputmode="inputmode" @click:append="lines.splice(index, 1)"></input-text>
		<input-text v-model="additional" :inputmode="inputmode" append-icon="essentials/basics/check-circle" @click:append="lines.push(additional); additional = '';"></input-text>
	</div>
</template>

<script>
	export default {
		props: ['value', 'inputmode', 'disabled', 'errors', 'label'],
		data() {
			return {
				lines: (this.value)?this.value:[],
				additional: ''
			};
		},
		watch: {
			lines() {
				this.$emit('input', this.lines);
			},
			value() {
				if(!this.lines) {
					this.lines = [];
				}
				this.lines = this.value;
				this.additional = '';
			}
		}
	}
</script>